/* eslint-disable max-len */
import React from 'react'
import AnimatedList from '../../../../components/Animation/AnimatedList'
import { convertEpochToDateFormat } from '../../../../CommonMethods/DateConversion'
import { useSelector } from 'react-redux'
const TableBody=({tableData,
    indexNum,
})=>{

    const dateformat=useSelector(state=>state?.systemConfigData?.globalVariables?.date_format)
    const date = convertEpochToDateFormat(tableData?.timestamp,dateformat)
    let seperated_DeviceInfo=tableData?.device_information?.split('|')
    return(
        <>
            <AnimatedList
                id={tableData.user_id}
                rowStatus={tableData.status}
                keyItem={indexNum}
                child={
                    <>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624] rounded-tl-[2px] rounded-bl-[2px]">{tableData?.user_id}</td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{tableData?.user_name}</td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]" id="field" >{date}</td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{(tableData?.timezone===undefined||tableData?.timezone==='') ? "-" : tableData?.timezone}</td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{tableData?.action===""?"-":tableData?.action}</td>
                        
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{(tableData?.ip_address===undefined||tableData?.ip_adress==="") ? "-" : tableData?.ip_address}</td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{seperated_DeviceInfo[0]},<br/>{seperated_DeviceInfo[1]},<br/>{seperated_DeviceInfo[2]}</td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{tableData?.result}</td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{(tableData?.value===undefined||tableData?.value==='')?"-":tableData?.value}</td>
                    </>
                    
                }/>
           
        </>
    )
}

export default TableBody